import { SelectOptionProps } from '@acceso/design-system';
import { useTranslation } from 'react-i18next';

import { ChannelScopeEnum } from '../types';

export function useChannelScopeOptions(): SelectOptionProps<ChannelScopeEnum | null>[] {
  const { t } = useTranslation();

  return [
    {
      label: t('Ninguno'),
      value: null,
    },
    {
      label: t('Nacional'),
      value: ChannelScopeEnum.NACIONAL,
    },
    {
      label: t('Regional'),
      value: ChannelScopeEnum.REGIONAL,
    },
    {
      label: t('Subregional'),
      value: ChannelScopeEnum.SUBREGIONAL,
    },
    {
      label: t('Local'),
      value: ChannelScopeEnum.LOCAL,
    },
  ];
}
